var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgKrw = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_16350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.174 12.2654C16.174 13.3089 14.3052 15.9176 12.0001 15.9176C9.69489 15.9176 7.82617 13.3089 7.82617 12.2654C7.82617 9.96022 9.69489 8.09155 12.0001 8.09155C14.3052 8.09155 16.174 9.96022 16.174 12.2654Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.174 12.2673C16.174 14.5726 14.3052 16.4412 12.0001 16.4412C9.69489 16.4412 7.82617 14.5726 7.82617 12.2673",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5345 14.8481L16.4277 15.9548L17.1656 16.6927L18.2723 15.5859L17.5345 14.8481Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6888 16.6957L14.582 17.8025L15.3199 18.5403L16.4266 17.4336L15.6888 16.6957Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7474 17.0629L18.6406 18.1697L19.3785 18.9075L20.4852 17.8008L19.7474 17.0629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9036 18.9067L16.7969 20.0134L17.5347 20.7513L18.6415 19.6445L17.9036 18.9067Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6419 15.9575L17.5352 17.0642L18.273 17.8021L19.3798 16.6953L18.6419 15.9575Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7962 17.8012L15.6895 18.908L16.4273 19.6458L17.5341 18.5391L16.7962 17.8012Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6893 5.62457L18.6406 8.57593L19.3785 7.83808L16.4271 4.88673L15.6893 5.62457Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5827 6.7348L15.6895 7.84155L16.4273 7.10374L15.3205 5.99698L14.5827 6.7348Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4265 8.57855L17.5332 9.6853L18.271 8.94749L17.1643 7.84074L16.4265 8.57855Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7956 4.51995L17.9023 5.62671L18.6402 4.88886L17.5334 3.7821L16.7956 4.51995Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6413 6.3637L19.748 7.47046L20.4859 6.73261L19.3791 5.62586L18.6413 6.3637Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.20331 20.0156L4.25195 17.0642L3.5141 17.8021L6.46546 20.7534L7.20331 20.0156Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.30988 18.9053L7.20312 17.7986L6.46531 18.5364L7.57207 19.6431L8.30988 18.9053Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46613 17.0616L5.35938 15.9548L4.62153 16.6927L5.72828 17.7994L6.46613 17.0616Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.4162 17.8007L6.46484 14.8494L5.727 15.5872L8.67836 18.5386L9.4162 17.8007Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25177 7.4726L7.20312 4.52124L6.46528 3.78339L3.51392 6.73475L4.25177 7.4726Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.35723 8.57807L8.30859 5.62671L7.57075 4.88886L4.61938 7.84022L5.35723 8.57807Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.46661 9.68354L9.41797 6.73218L8.68015 5.99436L5.7288 8.94572L6.46661 9.68354Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_16350"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgKrw);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/KRW.352118e14716db613b276d68266201b3.svg";